// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxDropDownBoxComponent, DxTabPanelComponent } from 'devextreme-angular';

// cc-common imports
import { DxWidgetUtils, Utils } from 'cc-common';

// component import
import { GridCellMultiColumnSelectorComponent } from '../../../../management-common/component/common/grid-cell-multi-column-selector/grid-cell-multi-column-selector.component';

// model imports
import { GLAccountLabelSelectorResultDto } from '../../_models/common/gl-account/gl-account-label-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../_models/common/gl-account/glaccount-selector-result-dto';
import { AccountSelectorInfo } from '../../_models/common/gl-account/account-selector-info';

@Component({
    selector: 'app-account-selector',
    templateUrl: './account-selector.component.html',
    styleUrls: ['./account-selector.component.scss']
})
export class AccountSelectorComponent implements OnInit {
    @ViewChild('selectorDropdownBox', { static: false }) selectorDropdownBox: DxDropDownBoxComponent;
    @ViewChild('accountLabelSelector', { static: false }) accountLabelSelector: GridCellMultiColumnSelectorComponent;
    @ViewChild('glAccountSelector', { static: false }) glAccountSelector: GridCellMultiColumnSelectorComponent;
    @ViewChild('offsetGLAccountSelector', { static: false })
    offsetGLAccountSelector: GridCellMultiColumnSelectorComponent;
    @ViewChild('selectorTabPanel', { static: false }) selectorTabPanel: DxTabPanelComponent;

    @Input() accountTypeSource: any[];
    @Input() glAccountLabelSource: Array<GLAccountLabelSelectorResultDto> = [];
    @Input() glAccounts: Array<GLAccountSelectorResultDto> = [];
    @Input() value: any;
    @Input() selectedAccountLabel: string = null;
    @Input() selectedGLAccountNumber: string = null;
    @Input() selectedOffsetAccount: string;
    @Input() selectedAccountType = 'account_label';
    @Input() defaultOffsetGLAccountNumber: string;
    @Input() disableOffsetGLAccount = false;
    @Input() cellInfo: any = {};

    @Output() onSelection = new EventEmitter<AccountSelectorInfo>();

    selectedAccountName: string;
    selectedAccountValueExpr: string;
    selectedAccountDisplayExpr: string;
    selectedTabItem: any;

    accountLabelBoxValue: Array<string> = [];
    accountLabelColumns: Array<any> = [];

    glAccountBoxValue: Array<string> = [];
    offsetGlAccountBoxValue: Array<string> = [];
    glAccountColumns: Array<any> = [];

    accountSource: Array<GLAccountLabelSelectorResultDto> | Array<GLAccountSelectorResultDto> = [];
    selectedAccountCode: string;

    ngOnInit() {
        if (Utils.notNullAndDefined(this.cellInfo.data.accountLabelCode)) {
            this.selectedAccountType = 'account_label';
            this.selectedAccountLabel = this.cellInfo.data.accountLabelCode;
        } else if (Utils.notNullAndDefined(this.cellInfo.data.glAccountNumber)) {
            this.selectedAccountType = 'account_number';
            this.selectedGLAccountNumber = this.cellInfo.data.glAccountNumber;
        } else {
            this.selectedAccountType = 'account_label';
            this.accountSource = this.glAccountLabelSource;
        }
        this.configureAccount();
    }

    onTabSelection(): void {
        if (Utils.notNullAndDefined(this.selectedTabItem)) {
            this.selectedAccountType = this.selectedTabItem.name;
            this.configureAccountSource();
        }
        this.setContentFocus();
    }

    onAccountLabelSelection(selectedObject: any): void {
        if (
            Utils.notNullAndDefined(selectedObject) &&
            Utils.notNullOrEmpty(selectedObject.selectedRow) &&
            Utils.notEqualsIgnoreCase(selectedObject.selectedRow[0].code, this.selectedAccountCode)
        ) {
            const selectedRowsData = selectedObject.selectedRow;
            this.resetGLAccount();
            this.selectedAccountCode = selectedRowsData[0].code;
            this.selectedAccountName = `${selectedRowsData[0].title};${selectedRowsData[0].glAccountNumber}`;
            this.selectedAccountLabel = selectedRowsData[0].code;
            this.accountLabelBoxValue = [selectedRowsData[0].code];

            const accountSelectorInfo: AccountSelectorInfo = new AccountSelectorInfo();
            accountSelectorInfo.accountType = this.selectedAccountType;
            accountSelectorInfo.title = this.selectedAccountName;
            accountSelectorInfo.accountLabelCode = selectedRowsData[0].code;
            accountSelectorInfo.glAccountNumber = selectedRowsData[0].glAccountNumber;
            accountSelectorInfo.offsetGLAccountNumber = selectedRowsData[0].offsetGLAccountNumber;
            accountSelectorInfo.disableSubCategory = true;
            accountSelectorInfo.subCategoryCode = selectedRowsData[0].subCategoryCode;

            this.setAccountSelection(accountSelectorInfo);

            setTimeout(() => {
                this.accountLabelSelector.removeComponentFocus();
                this.closeDropdownbox();
            }, 500);
        }
    }

    onGLAccountSelection(selectedObject: any): void {
        if (
            Utils.notNullAndDefined(selectedObject) &&
            Utils.notNullOrEmpty(selectedObject.selectedRow) &&
            Utils.notEqualsIgnoreCase(this.selectedGLAccountNumber, selectedObject.selectedRow[0].glAccountNumber)
        ) {
            const selectedRowsData = selectedObject.selectedRow;
            this.selectedAccountName = `${selectedRowsData[0].title};${selectedRowsData[0].glAccountNumber}`;
            this.resetAccountLabel();
            this.selectedGLAccountNumber = selectedRowsData[0].glAccountNumber;
            this.selectedAccountCode = selectedRowsData[0].glAccountNumber;
            this.glAccountBoxValue = [selectedRowsData[0].glAccountNumber];

            const accountSelectorInfo: AccountSelectorInfo = new AccountSelectorInfo();
            accountSelectorInfo.accountType = this.selectedAccountType;
            accountSelectorInfo.title = this.selectedAccountName;
            accountSelectorInfo.accountLabelCode = null;
            accountSelectorInfo.glAccountNumber = selectedRowsData[0].glAccountNumber;
            accountSelectorInfo.offsetGLAccountNumber = Utils.notNullAndDefined(this.selectedOffsetAccount)
                ? this.selectedOffsetAccount
                : null;
            accountSelectorInfo.disableSubCategory = false;
            accountSelectorInfo.subCategoryCode = null;

            this.setAccountSelection(accountSelectorInfo);

            if (Utils.equals(this.offsetGlAccountBoxValue.length, 0)) {
                if (Utils.notNullAndDefined(this.offsetGLAccountSelector)) {
                    this.offsetGLAccountSelector.setComponentFocus();
                }
            }
        }
    }

    onOffsetGLAccountSelection(selectedObject: any): void {
        if (
            Utils.notNullAndDefined(selectedObject) &&
            Utils.notNullOrEmpty(selectedObject.selectedRow) &&
            Utils.notEqualsIgnoreCase(selectedObject.selectedRow[0].glAccountNumber, this.selectedOffsetAccount)
        ) {
            const selectedRowsData = selectedObject.selectedRow;
            this.resetAccountLabel();
            this.selectedOffsetAccount = selectedRowsData[0].glAccountNumber;

            this.offsetGlAccountBoxValue = [selectedRowsData[0].glAccountNumber];

            const accountSelectorInfo: AccountSelectorInfo = new AccountSelectorInfo();
            accountSelectorInfo.accountType = this.selectedAccountType;
            accountSelectorInfo.title = this.selectedAccountName;
            accountSelectorInfo.accountLabelCode = null;
            accountSelectorInfo.glAccountNumber = this.selectedGLAccountNumber;
            accountSelectorInfo.offsetGLAccountNumber = selectedRowsData[0].glAccountNumber;
            accountSelectorInfo.disableSubCategory = false;
            accountSelectorInfo.subCategoryCode = null;

            this.setAccountSelection(accountSelectorInfo);

            setTimeout(() => {
                this.offsetGLAccountSelector.removeComponentFocus();
                this.closeDropdownbox();
            }, 500);
        }
    }

    onAccountLabelKeyPressed(event: any): void {
        if (Utils.equalsIgnoreCase(event.event.key, 'tab')) {
            if (Utils.notNullAndDefined(event.event.shiftKey)) {
                this.closeDropdownbox();
            } else {
                this.accountLabelSelector.removeComponentFocus();
                this.selectedAccountType = 'account_number';
                this.configureAccount();
            }
        }
    }

    onGLAccountKeyPressed(event: any): void {
        if (Utils.equalsIgnoreCase(event.event.key, 'tab')) {
            if (Utils.notNullAndDefined(event.event.shiftKey)) {
                this.glAccountSelector.removeComponentFocus();
                this.selectedAccountType = 'account_label';
                this.configureAccount();
            } else {
                setTimeout(() => {
                    if (Utils.notNullAndDefined(this.offsetGLAccountSelector)) {
                        this.offsetGLAccountSelector.setComponentFocus();
                    }
                }, 100);
            }
        }
    }

    onOffsetGLAccountKeyPressed(event: any): void {
        if (Utils.equalsIgnoreCase(event.event.key, 'tab')) {
            if (Utils.notNullAndDefined(event.event.shiftKey)) {
                if (Utils.notNullAndDefined(this.glAccountSelector)) {
                    this.glAccountSelector.setComponentFocus();
                }
            } else {
                this.offsetGLAccountSelector.removeComponentFocus();
                this.closeDropdownbox();
            }
        }
    }

    onDropdownBoxKeyDown(event: any): void {
        if (Utils.notNullAndDefined(event) && Utils.notNullAndDefined(event.event)) {
            if (
                Utils.equalsIgnoreCase(event.event.key, 'escape') ||
                Utils.equalsIgnoreCase(event.event.key, 'tab') ||
                Utils.equalsIgnoreCase(event.event.key, 'shift')
            ) {
                event.component.close();
                event.component.blur();
            } else {
                this.onDropdownInput();
            }
        }
    }

    onDropdownBoxKeyUp(event: any): void {
        if (Utils.notNullAndDefined(event) && Utils.notNullAndDefined(event.event)) {
            event.component.open();
            if (
                Utils.equalsIgnoreCase(event.event.key, 'arrowdown') ||
                Utils.equalsIgnoreCase(event.event.key, 'enter')
            ) {
                setTimeout(() => {
                    this.selectorTabPanel.instance.registerKeyHandler('escape', () => {
                        this.selectorDropdownBox.instance.close();
                    });

                    this.selectorTabPanel.instance.registerKeyHandler('arrowdown', () => {
                        this.selectedAccountType = 'account_label';
                        this.configureAccount();
                    });
                }, 100);
            }
        }
    }

    onDropdownInput(): void {
        if (DxWidgetUtils.hasInstance(this.selectorDropdownBox)) {
            if (Utils.isFalse(this.selectorDropdownBox.instance.option('opened'))) {
                this.selectorDropdownBox.instance.open();
            }
        }
        this.configureAccount();
    }

    onDropdownValueChanged(event: any): void {
        if (Utils.isNullOrUndefined(event.value)) {
            this.resetAccountLabel();
            this.resetGLAccount();
            this.selectedAccountName = null;
            this.accountLabelBoxValue = [];
            this.glAccountBoxValue = [];
            this.offsetGlAccountBoxValue = [];
            const accountSelectorInfo: AccountSelectorInfo = new AccountSelectorInfo();
            accountSelectorInfo.accountType = this.selectedAccountType;
            accountSelectorInfo.title = this.selectedAccountName;
            accountSelectorInfo.accountLabelCode = null;
            accountSelectorInfo.glAccountNumber = null;
            accountSelectorInfo.offsetGLAccountNumber = null;
            accountSelectorInfo.disableSubCategory = false;
            accountSelectorInfo.subCategoryCode = null;

            this.setAccountSelection(accountSelectorInfo);
        }
    }

    onDropDownOpened(event: any): void {
        if (!!event) {
            this.setContentFocus();
            this.selectorDropdownBox.instance.open();
        }
    }

    private configureAccount(): void {
        this.selectedAccountName = this.value;
        if (Utils.isNullOrUndefined(this.selectedAccountType)) {
            if (Utils.notNullAndDefined(this.selectedGLAccountNumber)) {
                this.selectedAccountType = 'account_number';
            } else {
                this.selectedAccountType = 'account_label';
            }
        }

        this.accountLabelColumns = [
            {
                dataField: 'title',
                dataType: 'string',
                caption: 'Account Label'
            },
            {
                dataField: 'glAccountNumber',
                dataType: 'string',
                caption: 'GLAccount No'
            },
            {
                dataField: 'offsetGLAccountNumber',
                dataType: 'string',
                caption: 'Offset GLAccount No'
            }
        ];

        this.glAccountColumns = [
            {
                dataField: 'glAccountNumber',
                dataType: 'string',
                caption: 'GLAccount No'
            },
            {
                dataField: 'title',
                dataType: 'string',
                caption: 'Account Label'
            },
            {
                dataField: 'displayText',
                dataType: 'string',
                visible: false
            }
        ];

        this.configureAccountSource();
        this.setContentFocus();
    }

    private configureAccountSource(): void {
        if (
            Utils.notNullAndDefined(this.cellInfo.data.accountLabelCode) &&
            Utils.equalsIgnoreCase(this.selectedAccountType, 'account_label')
        ) {
            this.selectedAccountLabel = this.cellInfo.data.accountLabelCode;
            this.accountSource = this.glAccountLabelSource;
            this.selectedAccountValueExpr = 'code';
            this.selectedAccountDisplayExpr = 'title';
            this.selectedAccountCode = this.selectedAccountLabel;
        } else if (Utils.notNullAndDefined(this.cellInfo.data.glAccountNumber)) {
            this.selectedGLAccountNumber = this.cellInfo.data.glAccountNumber;
            this.accountSource = this.glAccounts;
            this.selectedAccountValueExpr = 'glAccountNumber';
            this.selectedAccountDisplayExpr = 'displayText';
            this.selectedAccountCode = this.selectedGLAccountNumber;
        }
    }

    private resetAccountLabel(): void {
        this.selectedAccountLabel = null;
    }

    private resetGLAccount(): void {
        this.selectedGLAccountNumber = null;
        this.selectedOffsetAccount = null;
    }

    private setAccountSelection(selectedObject: AccountSelectorInfo): void {
        this.onSelection.emit(selectedObject);
    }

    private setContentFocus(): void {
        this.setContentDefaults();
        setTimeout(() => {
            if (Utils.equalsIgnoreCase(this.selectedAccountType, 'account_number')) {
                if (Utils.notNullAndDefined(this.glAccountSelector)) {
                    this.glAccountSelector.setComponentFocus();
                }
            } else {
                if (Utils.notNullAndDefined(this.accountLabelSelector)) {
                    this.accountLabelSelector.setComponentFocus();
                }
            }
        }, 1000);
    }

    private setContentDefaults(): void {
        this.selectedTabItem = this.accountTypeSource.find((d) =>
            Utils.equalsIgnoreCase(d.name, this.selectedAccountType)
        );

        if (
            Utils.notNullAndDefined(this.selectedAccountLabel) &&
            Utils.equalsIgnoreCase(this.selectedAccountType, 'account_label')
        ) {
            this.accountLabelBoxValue = [this.selectedAccountLabel];
        } else if (Utils.equalsIgnoreCase(this.selectedAccountType, 'account_number')) {
            if (Utils.notNullAndDefined(this.selectedGLAccountNumber)) {
                this.glAccountBoxValue = [this.selectedGLAccountNumber];
            }

            /* Set defaultOffsetGLAccountNumber if selectedOffsetAccount value
              is getting null from API side */
            if (Utils.isNullOrEmpty(this.selectedOffsetAccount)) {
                this.selectedOffsetAccount = this.defaultOffsetGLAccountNumber;
            }

            this.offsetGlAccountBoxValue = [this.selectedOffsetAccount];
        }
    }

    private closeDropdownbox(): void {
        this.selectorDropdownBox.instance.close();
    }
}
